import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConfigModule, DeferLoadingStrategy, I18nModule} from '@spartacus/core';
import {MatSidenavModule} from '@angular/material/sidenav';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedWidgetsComponent} from './shared-widgets.component';

import {PxSurveyWidgetComponent} from '../px-survey/px-survey-widget.component';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SupportWidgetComponent: {
          component: SharedWidgetsComponent,
          deferLoading: DeferLoadingStrategy.INSTANT,
        },
      },
    }),
    I18nModule,
    CommonModule,
    MatSidenavModule,
    BrowserAnimationsModule,
    PxSurveyWidgetComponent,
    SharedWidgetsComponent,
  ],
  exports: [SharedWidgetsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedWidgetsModule {}
